/**
* 左边菜单
*/ 
<template>
  <div>
    <el-menu default-active="2" :collapse="collapsed" collapse-transition router :default-active="$route.path"
      unique-opened class="el-menu-vertical-demo" background-color="#334157" text-color="#fff"
      active-text-color="#ffd04b">
      <div class="logobox">
        <img class="logoimg" src="../assets/img/logo.png" alt />
        <div class="logoname" v-if="show">舜泰汽车</div>
      </div>
      <el-submenu v-for="menu in allmenu" :key="menu.id" :index="menu.title">
        <template slot="title">
          <i class="iconfont" :class="menu.icon"></i>
          <span>{{ menu.title }}</span>
        </template>
        <el-menu-item-group>
          <el-menu-item v-for="chmenu in menu.subs" :index="'/' + chmenu.index" :key="chmenu.id">
            <i class="iconfont" :class="chmenu.icon"></i>
            <span>{{ chmenu.title }}</span>
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>
    </el-menu>
  </div>

</template>
<script>
import { get_menu_list } from '../api/menu.js'
export default {
  name: "leftnav",
  data() {
    return {
      collapsed: false,
      show: true,
      allmenu: [],
    };
  },
  // 创建完毕状态(里面是操作)
  created() {
    // 获取图形验证码
    this.getMenu()
    this.$root.Bus.$on("toggle", (value) => {
      console.log(this.show);

      this.show = !this.show;
      console.log(this.show);
      this.collapsed = !value;
    });
  },
  methods: {
    getMenu() {
      get_menu_list().then(res => {
        if (res["code"] === 0) {
          this.allmenu = res.data;
        }
      })
    }
  }
};
</script>
<style>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 240px;
  min-height: 400px;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  border: none;
  text-align: left;
}

.el-menu-item-group__title {
  padding: 0px;
}

.el-menu-bg {
  background-color: #1f2d3d !important;
}

.el-menu {
  border: none;
}

.logobox {
  width: 100%;
  height: 40px;
  display: flex;

  line-height: 40px;
  color: #9d9d9d;
  font-size: 20px;
  text-align: center;
  padding: 20px 0px;
}

.logoimg {
  height: 40px;
  margin-left: 15%;
  margin-right: 5%;
}

.logoname {
  overflow: hidden;
}
</style>


// WEBPACK FOOTER //
// src/components/leftnav.vue